// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  
  // url : 'http://192.168.2.34:8000/',  //lovepreet
  // web : 'https://big4health.com/'

  // url : 'http://192.168.2.88:8000/',   //prajwal
  // web : 'https://big4health.com/'

  // url : 'https://staging-api.big4healthapp.com/',
  // web : 'https://staging.big4healthapp.com/',
  
  url : 'https://api.big4health.com/',
  web : 'https://big4health.com/'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
